module.exports = __webpack_public_path__ + "static/media/img3.9de0fe80.jpg";